export function isDifferentFromBase<T>(
  values: (T | undefined | null)[],
  index: number,
  equals: (a: T, b: T) => boolean = (a, b) => a === b
): boolean {
  if (index === 0 || values.length === 0) return false;
  const base = values[0];
  const current = values[index];

  if (base == null && current == null) return false;
  if ((base == null) !== (current == null)) return true;

  return !equals(base as T, current as T);
}

export function hasAnyDifference<T>(
  values: (T | undefined | null)[],
  equals?: (a: T, b: T) => boolean
): boolean {
  for (let i = 1; i < values.length; i += 1) {
    if (isDifferentFromBase(values, i, equals as any)) return true;
  }
  return false;
}
